import * as API from './api';
import * as actionTypes from './actiontypes';

export function getFiltersData() {
    return function (dispatch) {
        dispatch({
            type: actionTypes.FILTERS_LOADING
        });

        API.getFiltersData((error, response) => {
            if (!error) {
                dispatch({
                    type: actionTypes.FILTERS_RECEIVED,
                    payload: response,
                });
            }
            else {
                dispatch({
                    type: actionTypes.FILTERS_ERROR,
                });
            }
        });
    };
}



// WEBPACK FOOTER //
// ./src/data/redux/filter_details/actions.js